import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { Link, LinkProps } from 'react-router-dom';
import { MainPageNavigatorConstants as ui, MAX_RECENT_NOTIFICATIONS } from '../../Config/UIConstants';
import { Table } from '../../Pages/NotificationsPage/Table';
import { Routes } from '../../_controllers/RouteController';
import { ApplicationStore } from '../../_stores/ApplicationStore';
import { LinkArrow, NotificationTopBar } from '../../images/images';
import { colors } from '../../styles/colors';
import { NotificationBodyText } from '../NotificationBodyText';
import { NotificationTimeText } from '../NotificationTimeText';

interface IProps extends RouteComponentProps<{}> {
    store?: ApplicationStore;
    onOverlayClick?(): void;
    style?: React.CSSProperties;
}

@inject('store')
@observer
export class NotificationsDropdownComponent extends React.Component<IProps> {
    private renderTable() {
        const recentNotifications = this.props.store!.notificationStore.recentNotifications.slice(0, MAX_RECENT_NOTIFICATIONS);
        return (
            <Table
                style={{...styles.table}}
                data={recentNotifications}
                RowCellsComponent={({item}) => {
                    const { icon, text, createdDateTime, isRead } = item;
                    const NotificationLink = (props: Partial<LinkProps>) => (
                        <Link
                            // to={item.linkUrl || ''}
                            // to={'/viewstory/5/18'}
                            to={{
                                pathname: item.linkUrl || '',
                                state: {scrollToSelected: true}
                            }}
                            onClick={() => {
                                if (this.props.onOverlayClick) {
                                    this.props.onOverlayClick();
                                }
                                if (item.id) {
                                    this.props.store!.notificationStore.markNotificationAsRead(item.id!);
                                }
                            }}
                            style={{...styles.notificationBodyContainer, ...props.style}}
                            {...props}
                        />
                    );

                    return <React.Fragment>
                        <div style={styles.notificationIconContainer}>
                            <img style={styles.notificationIcon} src={icon}/>
                        </div>
                        <NotificationLink style={styles.notificationBodyContainer}>
                            <NotificationBodyText isBold={!isRead}>{text}</NotificationBodyText>
                            <NotificationTimeText>{createdDateTime.fromNow()}</NotificationTimeText>
                        </NotificationLink>
                        <NotificationLink style={styles.notificationArrowContainer}>
                            <img style={styles.notificationArrow} src={LinkArrow}/>
                        </NotificationLink>
                    </React.Fragment>;
                }}
                rowStyle={styles.rowStyle}
            />
        );
    }

    public render() {
        return (
            <React.Fragment>

                {this.props.onOverlayClick && (
                    <div style={styles.overlay} onClick={this.props.onOverlayClick} />
                )}

                <div style={{...styles.container, ...this.props.style}}>
                    <img src={NotificationTopBar} style={styles.topImage} />
                    <div style={styles.header}>
                        <NotificationBodyText isBold={true}>{ui.NOTIFICATION_HEADER}</NotificationBodyText>
                        <div onClick={() => this.props.store!.notificationStore.markAllAsRead()}>
                            <NotificationBodyText style={styles.greenText} isBold={true}>
                                {ui.MARK_ALL_AS_READ}
                            </NotificationBodyText>
                        </div>
                    </div>
                    {this.renderTable()}
                    <Link to={Routes.NOTIFICATIONS} style={styles.footer}>
                        <NotificationBodyText style={styles.greenText} isBold={true}>
                            {ui.NOTIFICATION_FOOTER}
                        </NotificationBodyText>
                    </Link>
                </div>
            </React.Fragment>
        );
    }
}

export const NotificationsDropdown = withRouter<IProps>(NotificationsDropdownComponent);

const rowStyle: React.CSSProperties = { borderBottomWidth: 1, borderBottomStyle: 'solid', borderColor: colors.LIGHT_BORDER };
const styles = {
    overlay: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 10,
    } as React.CSSProperties,
    container: {
        position: 'absolute',
        top: 73,
        right: 96,
        width: 355,
        zIndex: 999,
        padding: 0,
        boxShadow: '0px 15px 30px 0 rgba(21,0,49,0.075)'
    } as React.CSSProperties,
    header: {
        width: '100%',
        paddingTop: 13,
        paddingBottom: 13,
        backgroundColor: 'white',
        marginTop: -1,
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        paddingLeft: 20,
        paddingRight: 20,
        alignItems: 'center',
        cursor: 'default',
        ...rowStyle
    } as React.CSSProperties,
    topImage: {
        width: '100%',
        objectFit: 'fill'
    } as React.CSSProperties,
    footer: {
        paddingTop: 15,
        paddingBottom: 9,
        borderBottomLeftRadius: 8,
        borderBottomRightRadius: 8,
        backgroundColor: 'white',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer'
    } as React.CSSProperties,
    notificationIconContainer: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        width: 51,
        paddingTop: 17
    } as React.CSSProperties,
    notificationIcon: {
        maxHeight: 21,
        maxWidth: 24
    } as React.CSSProperties,
    notificationBodyContainer: {
        display: 'flex',
        flexDirection: 'column',
        paddingTop: 17,
        paddingBottom: 22,
        flex: 1
    } as React.CSSProperties,
    notificationArrowContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 37,
        height: '100%'
    } as React.CSSProperties,
    notificationArrow: { width: 5.5, height: 9 } as React.CSSProperties,
    table: {
        backgroundColor: colors.WHITE,
        maxHeight: 'calc(100vh - 204px)',
        overflowY: 'auto'
    } as React.CSSProperties,
    greenText: { color: colors.ACTION_GREEN } as React.CSSProperties,
    rowStyle
};



// WEBPACK FOOTER //
// ./src/SharedComponents/MainPageWithNavigator/NotificationsDropDown.tsx